import React from 'react';
import Chip from '@mui/material/Chip';

// the look of the small outlined marks (NEW, BETA, the release month) in the sidebar and next to
// features. Dark mode: the secondary tone is too dim on the dark surfaces, the link tone reads
export const badgeSx = (theme) => {
  const color = theme.palette.mode === 'dark' ? theme.palette.link : theme.palette.secondary.main;
  return {
    backgroundColor: 'transparent',
    color,
    border: `1px solid ${color}`,
    fontWeight: 500,
    fontSize: '0.6rem',
    height: 16,
    flexShrink: 0,
    '& .MuiChip-label': { px: '4px' },
  };
};

// the small outlined "NEW" mark next to a feature that is new in this release; drop each use once
// the feature has been around for a while
const NewBadge = ({ sx = {} }) => (
  <Chip label="NEW" size="small" sx={(theme) => ({ ...badgeSx(theme), ...sx })} />
);

export default NewBadge;
